import axios from 'axios';

// const API_BASE_URL = 'http://localhost:5000/api';
const API_BASE_URL = 'https://reports.thead.com.au/api';


const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth token management
export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
};

// Auth API
export const authApi = {
  login: (credentials) => api.post('/auth/login', credentials),
  getCurrentUser: () => api.get('/auth/me'),
  updateProfile: (updates) => api.put('/auth/profile', updates),
  changePassword: (passwords) => api.put('/auth/change-password', passwords),
  setAuthToken
};

// Page API with slug support
export const pageApi = {
  getAll: () => api.get('/pages'),
  getById: (id, historyId) => api.get(`/pages/${id}`, { params: { historyId } }),
  getBySlug: (slug, historyId) => api.get(`/pages/slug/${slug}`, { params: { historyId } }),
  getPageIdFromSlug: (slug) => api.get(`/pages/slug/${slug}/id`),
  create: (data) => api.post('/pages', data),
  update: (id, data) => api.put(`/pages/${id}`, data),
  delete: (id) => api.delete(`/pages/${id}`),
  getChildren: (parentId) => api.get(`/pages/children/${parentId}`),
  search: (query) => api.get('/pages/search', { params: { q: query } }),
  getTree: () => api.get('/pages/tree'),
  getPagesByUser: () => api.get('/pages/user/pages'),
  duplicate: (id) => api.post(`/pages/${id}/duplicate`),

};

// Blocks API
export const blockApi = {
  createBlock: (pageId, data) => api.post(`/blocks/create`, data),
  saveBlocks: (pageId, blocks) => api.post(`/blocks/page/${pageId}`, { blocks }),
  updatePageBlocks: (pageId, blocks) => {
    // IMPORTANT: All spaces in block content must be preserved
    // The blocks JSON should include all whitespace/spaces exactly as they are
    // No trimming or whitespace normalization should occur
    return api.put(`/blocks/page/${pageId}`, { blocks });
  },
  updateBlock: (id, data) => api.put(`/blocks/${id}`, data),
  deleteBlock: (id) => api.delete(`/blocks/${id}`),
};

// History API
export const historyApi = {
  getPageHistory: (pageId, params) => api.get(`/history/page/${pageId}`, { params }),
  getTimelineEntries: (pageId, params) => api.get(`/history/page/${pageId}/entries`, { params }),
  getPageAtHistory: (pageId, historyId) => api.get(`/history/page/${pageId}/at/${historyId}`),
  getRecentSnapshots: (pageId, params) => api.get(`/history/page/${pageId}/recent`, { params }),
  getHistoryById: (historyId) => api.get(`/history/${historyId}`),
  restoreSnapshot: (historyId) => api.post(`/history/restore/${historyId}`),
};

// Upload API
export const uploadApi = {
  uploadFile: (file, type = 'image') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    
    return axios.post(`${API_BASE_URL}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

// Response interceptor
api.interceptors.response.use(
  (response) => {
    if (response.data !== undefined) {
      return response.data;
    }
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const errorMessage = error.response?.data || error.message;
    const errorData = typeof errorMessage === 'object' ? errorMessage : { message: errorMessage };

    console.error('API Error Details:', {
      status,
      url: error.config?.url,
      error: errorData,
      headers: error.config?.headers
    });

    // Only handle 401 errors
    if (status === 401) {
      // Clear local storage
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      // Redirect to login page only if not already there
      if (window.location.pathname !== '/login') {
        console.log('Redirecting to login due to 401 error');
        window.location.href = '/login?expired=true';
      }
    }

    return Promise.reject(errorData);
  }
);

export default api;